import ImageScanStatusHeaderRendererStyled from '../ImageScanStatusHeaderRenderer/ImageScanStatusHeaderRenderer.styled';
import { IHeaderParams } from 'ag-grid-community';
import React from 'react';
import { IconButton, Stack, Tooltip } from 'common/design-system/components-v2';
import { useTranslation } from 'react-i18next';

// TODO: create common component header for docs link
const BaseVendorImageHeaderRenderer: React.FC<IHeaderParams> = (props) => {
    const { t } = useTranslation('k8s_common');
    const { displayName } = props;
    const urlDoc = '/some-url';

    const onClickSort = () => {
        props.progressSort();
    };

    const onSeeDocsClicked = (e: React.MouseEvent) => {
        e.stopPropagation();
    };

    return (
        <ImageScanStatusHeaderRendererStyled.ColumnHeaderWrapper onClick={onClickSort}>
            <Stack direction='row' justifyContent='center' alignItems='center' spacing={1}>
                {displayName}
                {props.column.isSorting() && (
                    <span
                        className={`ag-icon ag-icon-${props.column.isSortAscending() ? 'asc' : 'desc'}`}
                        role='presentation'
                    ></span>
                )}
            </Stack>
            <Tooltip content={t('seeDocumentation')}>
                <Stack alignItems='center'>
                    <a onClick={onSeeDocsClicked} href={urlDoc} target='_blank' rel='noreferrer'>
                        <IconButton iconProps={{ name: 'book', size: 12 }} />
                    </a>
                </Stack>
            </Tooltip>
        </ImageScanStatusHeaderRendererStyled.ColumnHeaderWrapper>
    );
};

export default BaseVendorImageHeaderRenderer;
